// Bakes an optional watermark into the display copy, on the creator's device.
export const WM_STRENGTH = { subtle: 0.25, medium: 0.45, strong: 0.7 };
export const WM_PLACES = [["corner", "Corner"], ["center", "Center"], ["tiled", "Tiled"]];
export const EMPTY_WM = { on: false, text: "", place: "corner", strength: "subtle" };

export async function applyWatermark(file, maxPx, wm) {
  const bitmap = await createImageBitmap(file);
  const s = Math.min(1, maxPx / Math.max(bitmap.width, bitmap.height));
  const w = Math.round(bitmap.width * s), h = Math.round(bitmap.height * s);
  const canvas = document.createElement("canvas");
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(bitmap, 0, 0, w, h);
  const text = (wm.text || "").trim();
  if (wm.on && text) {
    const base = Math.min(w, h);
    const size = Math.max(12, Math.round(base * (wm.place === "center" ? 0.07 : wm.place === "tiled" ? 0.04 : 0.032)));
    ctx.font = `500 ${size}px "Playfair Display", Georgia, serif`;
    ctx.fillStyle = `rgba(255,255,255,${WM_STRENGTH[wm.strength] || WM_STRENGTH.subtle})`;
    ctx.shadowColor = "rgba(0,0,0,0.35)"; ctx.shadowBlur = Math.round(size / 6);
    if (wm.place === "corner") {
      ctx.textAlign = "right"; ctx.textBaseline = "bottom";
      ctx.fillText(text, w - size, h - size * 0.8);
    } else if (wm.place === "center") {
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      ctx.fillText(text, w / 2, h / 2);
    } else {
      ctx.textAlign = "center"; ctx.textBaseline = "middle";
      const stepX = ctx.measureText(text).width + size * 3, stepY = size * 5;
      ctx.save(); ctx.translate(w / 2, h / 2); ctx.rotate(-Math.PI / 6);
      const span = Math.hypot(w, h);
      for (let y = -span; y < span; y += stepY) for (let x = -span; x < span; x += stepX) ctx.fillText(text, x + ((y / stepY) % 2 ? stepX / 2 : 0), y);
      ctx.restore();
    }
  }
  const blob = await new Promise((r) => canvas.toBlob(r, "image/jpeg", 0.88));
  return new File([blob || file], "art.jpg", { type: "image/jpeg" });
}
